import React, { useEffect, useState } from "react";
import axios from "axios";
import { useUserAdmin } from "../../../admin/UserContext";
import { DataGrid } from "@mui/x-data-grid";
import { Container, Typography, Box, CircularProgress } from "@mui/material";

export const Reporte = () => {
  const [loading, setLoading] = useState(false);
  const [productos, setProducto] = useState([]);
  const { Token } = useUserAdmin();
  const backendURL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
  const fetchCantidad = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${backendURL}/api/reporte/producto`, {
        headers: { Authorization: `Bearer ${Token}` },
      });

      const dataConNombre = response.data.map((item) => ({
        ...item,
        nombre_completo: `${item.titulo_maquina || ""}  ${item.nombre_maquina || ""}`,
      }));

      setProducto(dataConNombre);
    } catch (error) {
      console.error("Error al obtener cantidades:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchCantidad();
}, [Token, backendURL]);

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 70,
    },
    {
  field: "nombre_completo",
  headerName: "Nombre",
  flex: 1,
  minWidth: 150
},
    {
  field: "imagen_producto",
  headerName: "Producto",
  flex: 1,
  minWidth: 160,
  renderCell: (params) => {
    const imagen = params.value;
    if (!imagen) return "Sin imagen";

    return (
        <Box sx={{display:'flex', alignItems:"center", justifyContent:'center'}}>
      <img
        src={`${backendURL}/${imagen}`}
        alt="Producto"
        style={{
          width: "80px",
          height: "auto",
          objectFit: "cover",
          borderRadius: 4,
          border: "1px solid #ccc",
        }}
      /></Box>
    );
  },
},
    {
      field: "cantidad",
      headerName: "Cantidad",
      flex: 1,
      minWidth: 120,
    },
  ];

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress size={80} thickness={6} />
      </Box>
    );
  }

  return (
    <Container sx={{ mt: 4 }}>
      <Typography
        variant="h5"
        sx={{ color: "#00A69E", fontWeight: "bold", mb: 2 }}
      >
        Productos preferidos
      </Typography>

      <Box
        sx={{
          height: 600,
          width: "100%",
          bgcolor: "#fff",
          boxShadow: 3,
          borderRadius: 2,
        }}
      >
        <DataGrid
          rows={productos}
          columns={columns}
          pageSize={8}
          rowsPerPageOptions={[8, 20, 50]}
          getRowId={(row) => row.id}
        getRowHeight={() => 150} 
          disableSelectionOnClick
          sx={{
            bgcolor: "#f0f0f0",
            color: "#585857",
            borderColor: "#585857",
            "& .MuiDataGrid-cell": {
              color: "#585857",
              borderColor: "#585857",
              display:'flex'
            },
            "& .MuiDataGrid-columnHeaders": {
              color: "#585857",
              borderColor: "#585857",
            },
            "& .MuiDataGrid-footerContainer": {
              color: "#585857",
              borderTop: "1px solid #585857",
            },
            "& .MuiSvgIcon-root": {
              color: "#585857",
            },
            "& .MuiCheckbox-root": {
              color: "#585857",
            },
            "& .MuiDataGrid-columnSeparator": {
              color: "#585857",
            },
          }}
        />
      </Box>
    </Container>
  );
};